/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { getMessageForInvalidParam, InvalidParam } from '@common/tech-shared';
import { Component, inject, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ErrorMessageComponent, FormFooterComponent, FormHeaderComponent, FormWrapperComponent } from '@ods/system';
import { FORM_SERVICE } from './form.service.token';

@Component({
  selector: '[odc-form]',
  imports: [FormWrapperComponent, FormHeaderComponent, FormFooterComponent, ErrorMessageComponent],
  template: `
    <ods-form-wrapper>
      @if (heading) {
        <ods-form-header [heading]="heading" />
      }
      <ng-content />
      <ods-form-footer>
        @for (errorMessage of formLevelErrors; track errorMessage) {
          <ods-error-message errors [text]="errorMessage" />
        }
        <ng-content select="[footer-left]" ngProjectAs="[left]" />
        <ng-content select="[footer-right]" ngProjectAs="[right]" />
      </ods-form-footer>
    </ods-form-wrapper>
  `,
})
export class FormComponent {
  @Input() heading: string;

  readonly formService = inject(FORM_SERVICE);

  get formLevelErrors(): string[] {
    const errors: ValidationErrors | null = this.formService.form.errors;
    if (!errors) return [];
    return Object.values(errors).map((invalidParam: InvalidParam) => getMessageForInvalidParam('', invalidParam));
  }
}
